import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Hero from '@/components/Hero.vue';
import PriceshowCategorySection from '@/components/priceshow/PriceshowCategorySection.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import PriceshowParamsInterface from '@/interfaces/PriceshowParamsInterface';
import {
  reactive,
  computed, watch, ref,
} from 'vue';
import {
  useStore,
} from 'vuex';
import {
  useRoute,
} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceshowPage',
  setup(__props) {

const route = useRoute();
const store = useStore();

const activeBranchSlugs = reactive<string[]>([
  route.params.branch as string,
]);

// const remainingBranches = computed(() => store.getters['branches/all'].filter((branch: BranchInterface) => !activeBranchSlugs.includes(branch.slug || '')));
const activeBranches = computed(() => store.getters['branches/all'].filter((branch: BranchInterface) => activeBranchSlugs.includes(branch.slug || '')));

const activeBranchParams = reactive<Record<string, PriceshowParamsInterface>>({
  [route.params.branch as string]: {
    branch: route.params.branch as string,
    productId: route.query.pid ? parseInt(route.query.pid as string, 10) : undefined,
    customerType: `${route.query.gewerbe}` === '1' ? 'business' : 'private',
    isCustomer: `${route.query.energiekunde}` === '1',
    double: !!route.params.usageHt,
    usage: parseInt(`${route.params.usage || 0}`, 10),
    usageHt: parseInt(`${route.params.usageHt || 0}`, 10),
    postcode: route.params.postcode as string,
    city: route.query.stadt as string,
    street: route.query.strasse as string,
    houseNumber: route.query.hausnummer as string,
  },
});

const heroMediaId = ref<number | `${number}`>();

const setHeroMediaId = () => {
  const firstBranch = activeBranches.value[0];

  if (!firstBranch) return;

  const priceshowMedia = firstBranch.media.priceshow;

  if (!priceshowMedia) return;

  heroMediaId.value = priceshowMedia;
};

watch(() => activeBranches.value[0], setHeroMediaId, {
  immediate: true,
  deep: true,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (heroMediaId.value)
      ? (_openBlock(), _createBlock(Hero, {
          height: "small",
          "font-color": "white",
          "background-position-x": "center",
          "background-position-y": "center",
          "media-id": heroMediaId.value,
          key: `priceshow-hero-${heroMediaId.value}`
        }, {
          headline: _withCtx(() => [
            _createTextVNode("Dein persönliches Angebot")
          ]),
          _: 1
        }, 8, ["media-id"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBranches.value, (branch, inx) => {
      return (_openBlock(), _createBlock(PriceshowCategorySection, {
        key: `priceshow-section--${branch.slug}`,
        branch: branch,
        modelValue: activeBranchParams[branch.slug],
        "onUpdate:modelValue": ($event: any) => ((activeBranchParams[branch.slug]) = $event),
        "section-props": {
      background: branch.mainCategory.key,
      wave: inx === 0 ? 'double-wave' : 'wave',
      waveNegative: true,
      paddingTop: false,
    }
      }, null, 8, ["branch", "modelValue", "onUpdate:modelValue", "section-props"]))
    }), 128))
  ], 64))
}
}

})